import React, { useEffect } from 'react';
import { Route, Switch } from 'wouter';
import CambiarClave from './Screens/CambiarClave';
import Login from './Screens/Login';
import Admin from './Screens/Admin';
import Home from './Screens/Home';
import Cotizador from './Screens/Cotizador';
import Credencial from './Screens/Credencial';
import SuscripcionExitosa from './Screens/SuscripcionExitosa';
import  {initGA, logPageView, logPageViewPath} from './functions/GoogleAnalytics';
import { useLocation } from 'wouter';
import PFs from './Screens/PFs';
import Buscador from './Screens/Buscador';

const App: React.FC = () => {

  const [location] = useLocation();

  useEffect(() => {
    //initGA('G-HG2DJXVJ40'); // Old ID Account
    initGA('G-B14KMQKH90');   // New ID Account
    logPageView();
  }, []);

  useEffect(() => {
    handleRouteChange(location);
  }, [location]);

  const handleRouteChange = (path: string) => {
    logPageViewPath(path);
  };

  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/cotizador" component={Cotizador} />
      <Route path="/Cotizador" component={Cotizador} />
      <Route path="/PFs" component={PFs} />
      <Route path="/SuscripcionExitosa" component={SuscripcionExitosa} />
      <Route path="/login" component={Login} />
      <Route path="/Login" component={Login} />
      <Route path="/admin" component={Admin} />
      <Route path="/Admin" component={Admin} />
      <Route path="/credencial" component={Credencial} />
      <Route path="/Credencial" component={Credencial} />
      <Route path="/CambiarClave" component={CambiarClave} />
      <Route path="/Cambiarclave" component={CambiarClave} />
      <Route path="/cambiarclave" component={CambiarClave} />
      <Route path="/buscador" component={Buscador} />
      <Route path="/Buscador" component={Buscador} />
    </Switch>
  );
};

export default App;